export default "__VITE_ASSET__v0KD2_vD__"